import React, { useEffect, useState } from 'react';

import { Radio, RadioChangeEvent, Typography } from 'antd';
import styled from 'styled-components';

import { REMINDER_TO_UPDATE_PRICING_STATUS } from './constants';
import SettingsModal from './SettingsModal';

const RadioGroup = styled(Radio.Group)`
  display: flex;
  flex-flow: column;
`;

const RadioButton = styled(Radio)`
  margin-top: 20px;
`;

type Props = {
  isOpen: boolean;
  onClose: () => void;
  communitiesToModify: any[];
  onSave: (newStatus: number) => void;
};

const ReminderToUpdatePricingModal = ({ onClose, onSave, isOpen, communitiesToModify }: Props) => {
  const [value, setValue] = useState<number | undefined>();

  useEffect(() => {
    if (!communitiesToModify.length || communitiesToModify.length > 1) {
      return;
    }
    setValue(communitiesToModify[0].reminder_to_update_pricing_status);
  }, [communitiesToModify]);

  const saveChanges = () => {
    if (!value) {
      return;
    }
    onSave(value);
    onClose();
  };

  return (
    <SettingsModal
      title={REMINDER_TO_UPDATE_PRICING_STATUS.title}
      onClose={onClose}
      onSave={saveChanges}
      isOpen={isOpen}
      communitiesToModify={communitiesToModify}
    >
      <Typography.Text style={{ fontSize: '14px', marginTop: '10px' }}>
        {REMINDER_TO_UPDATE_PRICING_STATUS.description}
      </Typography.Text>
      <RadioGroup onChange={(event: RadioChangeEvent) => setValue(event.target.value)} value={value}>
        <RadioButton value={REMINDER_TO_UPDATE_PRICING_STATUS.statusElements.OFF.value}>
          {REMINDER_TO_UPDATE_PRICING_STATUS.statusElements.OFF.label}
        </RadioButton>
        <RadioButton value={REMINDER_TO_UPDATE_PRICING_STATUS.statusElements.MONTHLY.value}>
          {REMINDER_TO_UPDATE_PRICING_STATUS.statusElements.MONTHLY.label}
        </RadioButton>
        <RadioButton value={REMINDER_TO_UPDATE_PRICING_STATUS.statusElements.EVERY_2_MONTHS.value}>
          {REMINDER_TO_UPDATE_PRICING_STATUS.statusElements.EVERY_2_MONTHS.label}
        </RadioButton>
        <RadioButton value={REMINDER_TO_UPDATE_PRICING_STATUS.statusElements.QUARTERLY.value}>
          {REMINDER_TO_UPDATE_PRICING_STATUS.statusElements.QUARTERLY.label}
        </RadioButton>
        <RadioButton value={REMINDER_TO_UPDATE_PRICING_STATUS.statusElements.EVERY_6_months.value}>
          {REMINDER_TO_UPDATE_PRICING_STATUS.statusElements.EVERY_6_months.label}
        </RadioButton>
      </RadioGroup>
    </SettingsModal>
  );
};

export default ReminderToUpdatePricingModal;
